import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useRemoveRoleMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { Role, useRolesTableContext } from '../../../../../../RolesTableContext'

export function useRemoveOptions(): RemoveRowActionOptions<Role> {
  const { refetch } = useRolesTableContext()
  const [removeRole] = useRemoveRoleMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveRole: {
        role: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreRole,
    onRemove: async ({ id }) => {
      await removeRole({ variables: { id } })
      refetch()
    },
  }
}
